module.exports = __webpack_public_path__ + "static/media/process_3.0542d13e.png";